import { render, staticRenderFns } from "./DefaultRightBar.vue?vue&type=template&id=6676101c&"
import script from "./DefaultRightBar.vue?vue&type=script&lang=js&"
export * from "./DefaultRightBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports